import moment, {Moment} from "moment";
import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class AcpSettingsService {
    async getAcpSettingsForCustomer(clientId: number) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AcpSettings/${clientId}`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async updateAcp24HFileForCustomer(clientId: number, settingId: number, dateTime: Moment) {
        const dateTimeNow = moment();
        dateTime.utc(true);
        dateTimeNow.utc(true);

        if (dateTime.isAfter(dateTimeNow)) {
            dateTime.subtract(1, 'day');
        }
        
        let url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/AcpSettings/${clientId}/settings/${settingId}/update24HFile?dateTime=${dateTime.toJSON()}`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'PATCH'
        });
        
        if (!response.ok) {
            throw new Error();
        }
        
        return response;
    }
}

export default new AcpSettingsService();
